import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle, faSync } from '@fortawesome/pro-solid-svg-icons'

import {
  Box, Button, SidebarModal, Text,
} from '@domain-group/suit-theme'

import useArtworkDataChanges from '@hooks/useArtworkDataChanges'

import type { UseArtworkPayload } from '@hooks/useArtwork'

import PageDataChanges from './PageDataChanges'

const renderTitle = (count: number) => {
  const string = `${count} ${count === 1 ? 'Change' : 'Changes'}`

  return (
    <Text color="orange">
      <FontAwesomeIcon icon={faExclamationCircle} /> {string} to Review
    </Text>
  )
}

interface DataChangesProps {
  artworkPayload: UseArtworkPayload,
}

const DataChanges = (props: DataChangesProps) => {
  const {
    artworkPayload: {
      artwork,
      callbacks: {
        patchArtworkData,
      },
      updating,
    },
  } = props

  const artworkDataChangesPayload = useArtworkDataChanges({
    artwork,
    callbacks: {
      patchArtworkData,
    },
    performHttpRequests: !!artwork.id,
  })

  const {
    artworkDataChanges: {
      count,
      pages,
    },
    artworkMappedChanges,
    callbacks: {
      syncDataChanges,
    },
    lastUpdated,
  } = artworkDataChangesPayload

  if (count === 0){
    return null
  }

  return (
    <SidebarModal.ExpandableSection
      label="Data Changes"
      title={renderTitle(count)}
      style={{ marginTop: 16 }}
    >
      <Box>
        {pages.map(page => (
          <PageDataChanges
            key={page.id}
            callbacks={{ syncDataChanges }}
            disableItemSync
            // @ts-expect-error TS2322
            page={page}
          />
        ))}
      </Box>

      <Box alignItems="center" borderBottom="1px dashed" borderColor="lineColor" paddingBottom="medium">
        <Button
          buttonStyle="secondaryCreate"
          // @ts-expect-error TS2322
          ghost={!updating}
          icon={<FontAwesomeIcon icon={faSync} />}
          loading={updating}
          size="tiny"
          onClick={() => syncDataChanges(artworkMappedChanges)}
          width="auto"
        >
          Sync All
        </Button>

        <Text color="lightGrey" fontSize="xsmall" marginLeft="auto">
          Updated {lastUpdated}
        </Text>
      </Box>
    </SidebarModal.ExpandableSection>
  )
}

export default DataChanges
